































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { RelatedPartType } from '@/entities/RelatedPartType';
import { RelatedPart as RelatedPartEntity } from '@/entities/RelatedPart';
import BaseMixin from '@/mixins/BaseMixin';
import ShoppingCartActions from '@/components/shopping-cart/ShoppingCartActions.vue';
import RelatedPartImage from '@/components/related-part/RelatedPartImage.vue';
import Price from '@/components/price/Price.vue';
import URI from 'urijs';
import { PartService } from '@/services/part-service';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import DeliveryTimeToolTip from '@/components/delivery-time-tooltip/DeliveryTimeToolTip.vue';
import _ from 'lodash';

@Component({
    components: {
        RelatedPartImage,
        ShoppingCartActions,
        Price,
        LoadingIndicator,
        DeliveryTimeToolTip,
    },
})
export default class RelatedPart extends Mixins(BaseMixin) {
    @Prop({ type: Object, required: true })
    private relatedPart!: RelatedPartEntity;
    @Prop({ type: String as () => RelatedPartType, required: true })
    private relatedPartType!: RelatedPartType;
    @Prop({ type: String, required: true })
    private partActionLink!: string;

    private quantity: number = 1;
    private isLoadingAvailability: boolean = false;
    private partService: PartService = new PartService();
    private reloadAvailabilityDebounced: () => Promise<void> | undefined;
    private showAvailability: boolean = true;

    constructor() {
        super();
        this.reloadAvailabilityDebounced = _.debounce(this.reloadAvailability, 500);
    }

    // called by vue
    public created(): void {
        this.reloadAvailability();
    }

    public get partDetailLink(): string {
        return new URI(this.partActionLink).addQuery('id', this.relatedPart.partId).toString();
    }

    public get isReplacement(): boolean {
        return RelatedPartType.Replacement === this.relatedPartType;
    }

    private get maxAllowedQuantity(): number | undefined {
        if (!this.relatedPart.isUsedPart) {
            return undefined;
        }

        return this.getAvailableItemCount();
    }

    private onQuantityChanged(quantity: number): void {
        this.quantity = quantity;
        this.reloadAvailabilityDebounced();
    }

    private onQuantityValid(): void {
        this.showAvailability = true;
    }

    private onQuantityInvalid(): void {
        this.showAvailability = false;
    }

    private async reloadAvailability(): Promise<void> {
        this.isLoadingAvailability = true;
        try {
            const availability = await this.partService.getAvailabilityOfPart(this.relatedPart.partId, this.quantity);
            if (!availability) {
                return;
            }
            this.relatedPart.partAvailability = availability;
        } catch {
            // ignore
        } finally {
            this.isLoadingAvailability = false;
        }
    }

    private getAvailableItemCount(): number {
        if (!this.relatedPart.partAvailability || !this.relatedPart.partAvailability.stockInfos) {
            return 0;
        }
        return this.relatedPart.partAvailability.stockInfos
            .map((info) => info.quantity)
            .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    }
}
